import React from 'react';
import { Link } from 'react-router-dom';

const PriceTable = () => {
    return (
        <section className="divider-both tp-is-fullwidth tp-is-stretched">
            <div className="stg-row stg-bottom-gap" data-unload="fade-up">
                <div className="stg-col-8 stg-offset-2 stg-tp-col-6 stg-tp-offset-3">
                    <div className="align-center">
                        <h2 data-split-appear="fade-up">Ready to set your brand ablaze?</h2>
                    </div>
                </div>
            </div>
            <div className="stg-row stg-bottom-gap-l" data-unload="fade-up" data-delay="100">
                <div className="stg-col-6 stg-offset-3 stg-tp-col-6 stg-tp-offset-3">
                    <div className="align-center">
                        <p className="infocolors-large-text" data-appear="fade-up" data-delay="100">
                            Browse our service packages 📦 and find the perfect spark ✨ to ignite your vision:
                        </p>
                    </div>
                </div>
            </div>
            
            <div className="swiper infocolors-carousel" data-appear="fade-up" data-delay="200" data-tp-count="2" data-unload="fade-up">
                <div className="swiper-wrapper">
                    <div className="infocolors-block infocolors-price-table swiper-slide">
                        <h6>Branding Spark<span className="infocolors-accent">.</span></h6>
                        <p>We weave visual stories and craft strategic messaging that resonate.</p>
                        <div className="infocolors-price-wrapper">
                            <div className="infocolors-label">Starting at</div>
                            <h2>$3,000</h2>
                        </div>
                        <div className="infocolors-label infocolors-highlight">What is included</div>
                        <ul className="infocolors-marked-list">
                            <li>Brand identity development</li>
                            <li>Brand story and messaging</li>
                            <li>Basic brand guidelines document</li>
                            <li>Two branding consultations</li>
                        </ul>
                        <Link to="/contact" className="infocolors-button is-fullwidth">Order Now</Link>
                    </div>
                                            
                    <div className="infocolors-block infocolors-price-table swiper-slide">
                        <h6>Marketing Blaze<span className="infocolors-accent">.</span></h6>
                        <p>We design data-driven campaigns that crackle with energy.</p>
                        <div className="infocolors-price-wrapper">
                            <div className="infocolors-label">Starting at</div>
                            <h2>$5,000</h2>
                        </div>
                        <div className="infocolors-label infocolors-highlight">What is included</div>
                        <ul className="infocolors-marked-list">
                            <li>Social media strategy and content</li>
                            <li>Email marketing campaign</li>
                            <li>2 paid advertising campaigns</li>
                            <li>Ongoing marketing analytics</li>
                        </ul>
                        <Link to="/contact" className="infocolors-button is-fullwidth">Order Now</Link>
                    </div>
                                            
                    <div className="infocolors-block infocolors-price-table swiper-slide">
                        <h6>Content Inferno<span className="infocolors-accent">.</span></h6>
                        <p>We craft visual masterpieces that sing your brand's story.</p>
                        <div className="infocolors-price-wrapper">
                            <div className="infocolors-label">Starting at</div>
                            <h2>$7,000</h2>
                        </div>
                        <div className="infocolors-label infocolors-highlight">What is included</div>
                        <ul className="infocolors-marked-list">
                            <li>Website copywriting and SEO</li>
                            <li>Blog post and article creation</li>
                            <li>Video scriptwriting and production</li>
                            <li>Content management</li>
                        </ul>
                        <Link to="/contact" className="infocolors-button is-fullwidth">Order Now</Link>
                    </div>
                                            
                    <div className="infocolors-block infocolors-price-table swiper-slide">
                        <h6>Design Revolution<span className="infocolors-accent">.</span></h6>
                        <p>Imagine your website as a warm, inviting space for potential customers.</p>
                        <div className="infocolors-price-wrapper">
                            <div className="infocolors-label">Starting at</div>
                            <h2>$10,000</h2>
                        </div>
                        <div className="infocolors-label infocolors-highlight">What is included</div>
                        <ul className="infocolors-marked-list">
                            <li>Website design and development</li>
                            <li>Graphic design for marketing</li>
                            <li>UI and UX design</li>
                            <li>Design system creation</li>
                        </ul>
                        <Link to="/contact" className="infocolors-button is-fullwidth">Order Now</Link>
                    </div>
                                            
                    <div className="infocolors-block infocolors-price-table swiper-slide">
                        <h6>Growth Ascension<span className="infocolors-accent">.</span></h6>
                        <p>Let your visuals become the unforgettable face of your brand.</p>
                        <div className="infocolors-price-wrapper">
                            <div className="infocolors-label">Starting at</div>
                            <h2>$15,000</h2>
                        </div>
                        <div className="infocolors-label infocolors-highlight">What is included</div>
                        <ul className="infocolors-marked-list">
                            <li>Advanced marketing</li>
                            <li>ROI optimization</li>
                            <li>Brand ambassador programs</li>
                            <li>Regular brand strategy</li>
                        </ul>
                        <Link to="/contact" className="infocolors-button is-fullwidth">Order Now</Link>
                    </div>
                </div>
                <div className="swiper-pagination infocolors-dots"></div>
            </div>
        </section>
    );
};

export default PriceTable;
